import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useStyletron } from 'styletron-react'
import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import useModal from '@/shared/hooks/useModal'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { selectCurrentContractActive } from '../../../SubscriptionForm/SubscriptionFormSelectors'

const useAbandonContract = () => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const dispatch = useDispatch()
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setLoading] = useState(false)
  const { isOpen, setIsOpen } = useModal()
  const { isAdmin } = useSelector(selectAuthData)
  const { type, id } = useRetrieveActiveContractIdAndType()
  const canShowAbandonButton = isAdmin && ['Energy', 'Telecom', 'Insurance'].includes(type)
  const { status = null } = useSelector(selectCurrentContractActive) || {}
  const isAlreadyRetracted = status === 'R0500' || status === 'R0400'

  const handleResponse = (success, status) => {
    if (status === 200) {
      setLoading(false)
      setIsOpen(false)
      return
    }
    setLoading(false)
    setError(t('subscriptionTable:save_error'))
    console.error('Abandon contract error', success)
  }

  const sendReason = () => {
    setLoading(true)
    setError('')
    if (reason.length === 0) {
      setError(t('subscriptionTable:mandatory_field'))
      setLoading(false)
      return
    }
    dispatch({
      type: subscriptionFormActionsV2.RETRACT_CONTRACT_V2,
      reason,
      id,
      callback: handleResponse,
    })
  }

  return {
    t,
    css,
    reason,
    error,
    isLoading,
    sendReason,
    setReason,
    isOpen,
    setIsOpen,
    canShowAbandonButton,
    isAlreadyRetracted,
  }
}

export default useAbandonContract
